/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Ex_IntroInputs */

const en_formatter_ex_intro = /** @type {(inputs: Formatter_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A typical minified API payload, formatted with two space indentation.`)
};

const ko_formatter_ex_intro = /** @type {(inputs: Formatter_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전형적인 압축 API 페이로드를 2칸 들여쓰기로 포매팅한 결과입니다.`)
};

const ja_formatter_ex_intro = /** @type {(inputs: Formatter_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`典型的な圧縮済み API ペイロードを 2 スペースインデントで整形した結果です。`)
};

/**
* | output |
* | --- |
* | "A typical minified API payload, formatted with two space indentation." |
*
* @param {Formatter_Ex_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_ex_intro = /** @type {((inputs?: Formatter_Ex_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Ex_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_ex_intro(inputs)
	if (locale === "ko") return ko_formatter_ex_intro(inputs)
	return ja_formatter_ex_intro(inputs)
});